import React, { useCallback, useMemo } from 'react';
import { Dialog } from '@mui/material';
import { borderRadius, shadows } from '../../constants';
import RaiseQueryForm from './RaiseQueryForm';

// Region label to code mapping (same as in RaiseQueryCreate)
const REGION_MAPPING = {
  'All': 'ALL',
  'all': 'ALL',
  'All Regions': 'ALL',
  'all regions': 'ALL',
  'North Region': 'NR',
  'north region': 'NR',
  'Northern Region': 'NR',
  'northern region': 'NR',
  'South Region': 'SR',
  'south region': 'SR',
  'Southern Region': 'SR',
  'southern region': 'SR',
  'East Region': 'ER',
  'east region': 'ER',
  'Eastern Region': 'ER',
  'eastern region': 'ER',
  'West Region': 'WR',
  'west region': 'WR',
  'Western Region': 'WR',
  'western region': 'WR',
  'North East': 'NER',
  'north east': 'NER',
  'North Eastern Region': 'NER',
  'north eastern region': 'NER',
  // 'Head Office': 'HO',
  // 'head office': 'HO',
  // 'HO Region': 'HO',
  // 'ho region': 'HO',
  // 'HO': 'HO',
  'NER': 'NER',
  'NR': 'NR',
  'SR': 'SR',
  'ER': 'ER',
  'WR': 'WR',
  'ALL': 'ALL',
};

const mapRegionToCode = (regionLabel) => {
  if (!regionLabel) return '';
  const trimmed = regionLabel.trim();
  return REGION_MAPPING[trimmed] || trimmed;
};

const RaiseQueryModal = ({ 
  open, 
  onClose, 
  onSuccess,
  // URL parameters
  visualDescription = '',
  region = '',
  project = '',
  projectName = '',
  queryType = '',
  priority = '',
  assigneeId = '',
}) => {
  const handleSuccess = useCallback(() => {
    onSuccess?.();
    onClose?.();
  }, [onSuccess, onClose]);

  // Map region label to code
  const regionCode = useMemo(() => {
    return mapRegionToCode(region);
  }, [region]);

  // Use project or projectName (project takes precedence)
  const finalProjectName = useMemo(() => {
    return project || projectName;
  }, [project, projectName]);

  // Decode URL-encoded visualDescription (handle double-encoding)
  const decodedVisualDescription = useMemo(() => {
    if (!visualDescription) {
      return '';
    }
    
    try {
      let decoded = visualDescription;
      let previousDecoded = '';
      let decodeCount = 0;
      while (decoded.includes('%') && decoded !== previousDecoded && decodeCount < 5) {
        previousDecoded = decoded;
        try {
          decoded = decodeURIComponent(decoded);
          decodeCount++;
        } catch (e) {
          break;
        }
      }
      return decoded;
    } catch (error) {
      // console.error('Error decoding visualDescription:', error);
      return visualDescription;
    }
  }, [visualDescription]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: borderRadius.modal,
          boxShadow: shadows.xl,
          maxHeight: '95vh',
          overflow: 'hidden',
        },
      }}
    >
      {open && (
        <RaiseQueryForm
          layout="modal"
          isActive={open}
          onCancel={onClose}
          onSuccess={handleSuccess}
          heading="Raise New Query"
          visualDescription={decodedVisualDescription}
          initialRegion={regionCode}
          initialProjectName={finalProjectName}
          initialQueryType={queryType || 'GENERAL'}
          initialPriority={priority || 'high'}
          initialAssigneeId={assigneeId}
          hasUrlParams={!!(region || projectName || project || visualDescription)}
        />
      )}
    </Dialog>
  );
};

export default RaiseQueryModal;
